$(document).ready(function(){ 

   $('span.deferred-media__poster-button.motion-reduce').click();
  if ($("details.menu-drawer-container").hasClass("custom_desktop_only")) {
$('body').addClass('fixed-left-menu-cstm')
    }
// header menu hover show menu drawer start
  
$('body').on('mouseenter','ul.menu-drawer__menu.has-submenu.list-menu li',function () {
   $('.custom_menu_jtpl.menu-drawer__submenu.has-submenu').removeClass('sub_menu_transition_jtpl');
$(this).find('.custom_submenu_jtpl_open_hover').addClass('menu-opening');
    $(this).find('.custom_submenu_jtpl_open_hover').attr('open','open');
    $(this).parents('ul').addClass('submenu-open');
   if($('.custom_submenu_jtpl_open_hover').hasClass('menu-opening')) {
    
$('.custom_header_menu_overlay').addClass('custom_hover_overlay');
     
 }
  // 05-09-2024 code comment
     // $(this).find("svg.icon.icon-plus").hide();
     // $(this).find("svg.icon.icon-minus").show();
  // 05-09-2024 code comment
  
  $(this).find('.custom_menu_jtpl.menu-drawer__submenu.has-submenu').addClass('sub_menu_transition_jtpl');
});
  
$('body').on('mouseleave','ul.menu-drawer__menu.has-submenu.list-menu li',function () {
$(this).find('.custom_submenu_jtpl_open_hover').removeClass('menu-opening');
    $(this).find('.custom_submenu_jtpl_open_hover').removeAttr('open','open');
    $(this).parents('ul').removeClass('submenu-open');
   $(this).find('.custom_menu_jtpl.menu-drawer__submenu.has-submenu').removeClass('sub_menu_transition_jtpl');
  $('.custom_header_menu_overlay').removeClass('custom_hover_overlay');

 // 05-09-2024 code comment
   // $(this).find("svg.icon.icon-plus").show();
   //  $(this).find("svg.icon.icon-minus").hide();
 // 05-09-2024 code comment
  
})
// header menu hover show menu drawer end
  // testimonial section slider start
$('.testimonial_outer_main').slick({
  dots: true,
  infinite: false,
   slidesToShow: 1,
  slidesToScroll: 1,
   arrows:false,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]

});
  // testimonial section slider end
  // recently viewed section slider start
//  setTimeout(function(){
//  $('ul.custom_related_product_slider').slick({
//   dots: false,
//   infinite: false,
//    slidesToShow: 4,
//   slidesToScroll: 1,
//    arrows:true,
//    nextArrow: '<div class="recently-viewed slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/></svg></div>',
//     prevArrow: '<div class="recently-viewed slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/></svg></div>',
// responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]

// });
//     }, 2000);
  // recently viewed section slider start
  // homepage tabs section start
var getLoadAttr = $('ul.custom_tabs_jtpl_warpper_ul_tab_heading li:first').attr('data-aatr');
$('ul.custom_tabs_jtpl_warpper_ul_tab_heading li:first').addClass('is-active');  
 $("ul.custom_tabs_jtpl_warpper_ul_tab_content li[data-aatr='" + getLoadAttr + "']").show();
  $('body').on('click','ul.custom_tabs_jtpl_warpper_ul_tab_heading li',function () {
    $('ul.custom_tabs_jtpl_warpper_ul_tab_heading li').removeClass('is-active')
$(this).addClass('is-active');
    $("ul.custom_tabs_jtpl_warpper_ul_tab_content li").hide();
var get_tab_heading = $(this).attr('data-aatr');
             console.log(get_tab_heading);
   
     $("ul.custom_tabs_jtpl_warpper_ul_tab_content li[data-aatr='" + get_tab_heading + "']").show();
})
   // homepage tabs section end
});
   // pdp slider section start
 $(window).on("load scroll resize",function(){
//    WindowWidth = $(window).width();
  
//    if (WindowWidth > 750) {
// $('.custom_product_vertical_tumbs .thumbnail-list ').slick({
//   dots: true,
//   infinite: false,
//    slidesToShow: 2,
//   slidesToScroll: 1,
//    arrows:false,
//     vertical: true,
// verticalSwiping: true
// });
//    }
  
   // pdp slider section end
   
             
  // homepage video slider start
  setTimeout(function() {
  if($('.custom_video_logo_jtpl').hasClass('slick-initialized')) {
   
        $('.custom_video_logo_jtpl').unslick();
      }
  WindowWidth = $(window).width();
  
   if (WindowWidth < 768) {
     
$('.custom_video_logo_jtpl').slick({
 dots: false,
  infinite: false,
  autoplay:true,
 slidesToShow: 1,
  slidesToScroll:1,
  arrow:false,
prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/></svg></div>'

});
   }
    }, 500);
  
});
// homepage video slider end

